import React from 'react';
import { useNavigate } from 'react-router-dom';
import { TrendingUp, Home, Calendar, Shield, Award } from 'lucide-react';
import { Button } from '@/components/ui/button';
import Header from '@/components/Header';
import Footer from '@/components/Footer';

export default function BuyBackPage() {
  const navigate = useNavigate();

  const investmentPlans = [
    { duration: '3 Months', rate: '18%', minAmount: '₦100,000', returns: '₦4,500', color: 'from-green-600 to-green-700' },
    { duration: '6 Months', rate: '18%', minAmount: '₦200,000', returns: '₦18,000', color: 'from-blue-600 to-blue-700', popular: true },
    { duration: '12 Months', rate: '18%', minAmount: '₦500,000', returns: '₦90,000', color: 'from-purple-600 to-purple-700' }
  ];

  const landInvestments = [
    { location: 'Lekki, Lagos', size: '500sqm', price: '₦15M', roi: '25% annually' },
    { location: 'Ajah, Lagos', size: '300sqm', price: '₦8M', roi: '22% annually' },
    { location: 'Ibeju-Lekki', size: '1000sqm', price: '₦20M', roi: '30% annually' }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />

      <section className="pt-32 pb-20 px-4 md:px-8 bg-gradient-to-br from-green-50 to-white">
        <div className="max-w-7xl mx-auto text-center">
          <h1 className="text-5xl md:text-7xl font-bold font-heading text-slate-900 mb-6">
            Buy-Back Investment
          </h1>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            Earn guaranteed 18% returns on fixed-term investments or invest in high-value land with appreciation potential
          </p>
        </div>
      </section>

      <section className="py-20 px-4 md:px-8">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-4xl font-bold font-heading text-slate-900 mb-4 text-center">Fixed Investment Plans</h2>
          <p className="text-lg text-slate-600 mb-12 text-center max-w-2xl mx-auto">
            Lock your funds for 3, 6, or 12 months and enjoy 18% annual returns
          </p>
          
          <div className="grid md:grid-cols-3 gap-8">
            {investmentPlans.map((plan, idx) => (
              <div key={idx} className={`relative bg-gradient-to-br ${plan.color} rounded-3xl p-8 text-white shadow-2xl ${plan.popular ? 'scale-105' : ''}`}>
                {plan.popular && (
                  <div className="absolute -top-4 left-1/2 -translate-x-1/2">
                    <span className="bg-yellow-400 text-slate-900 px-4 py-1 rounded-full text-sm font-bold">Most Popular</span>
                  </div>
                )}
                <div className="text-center mb-8">
                  <div className="text-6xl font-bold font-heading mb-2">{plan.rate}</div>
                  <div className="text-lg opacity-90">Annual Returns</div>
                </div>
                
                <div className="space-y-4 mb-8">
                  <div className="bg-white/10 rounded-xl p-4">
                    <div className="text-sm opacity-80 mb-1">Duration</div>
                    <div className="text-xl font-bold">{plan.duration}</div>
                  </div>
                  <div className="bg-white/10 rounded-xl p-4">
                    <div className="text-sm opacity-80 mb-1">Minimum Investment</div>
                    <div className="text-xl font-bold">{plan.minAmount}</div>
                  </div>
                  <div className="bg-white/10 rounded-xl p-4">
                    <div className="text-sm opacity-80 mb-1">Expected Returns (per ₦100k)</div>
                    <div className="text-xl font-bold">{plan.returns}</div>
                  </div>
                </div>

                <Button className="w-full bg-white text-slate-900 hover:bg-slate-100 rounded-xl py-6 font-semibold">
                  Invest Now
                </Button>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* <section id="land" className="py-20 px-4 md:px-8 bg-slate-50">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <Home className="w-16 h-16 text-brand-blue mx-auto mb-4" />
            <h2 className="text-4xl font-bold font-heading text-slate-900 mb-4">Land Investment Opportunities</h2>
            <p className="text-lg text-slate-600 max-w-2xl mx-auto">
              Invest in prime Lagos real estate. Buy land today, sell at a premium tomorrow
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {landInvestments.map((land, idx) => (
              <div key={idx} className="bg-white rounded-2xl p-6 shadow-sm border border-slate-200 hover:border-brand-blue transition-all">
                <img 
                  src={`https://images.unsplash.com/photo-1500382017468-9049fed747ef?q=80&w=2070&auto=format&fit=crop`}
                  alt="Land" 
                  className="w-full h-48 object-cover rounded-xl mb-6"
                />
                <h3 className="text-2xl font-bold text-slate-900 mb-4">{land.location}</h3>
                <div className="space-y-3 mb-6">
                  <div className="flex justify-between">
                    <span className="text-slate-600">Size</span>
                    <span className="font-semibold">{land.size}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-slate-600">Price</span>
                    <span className="font-semibold text-brand-blue">{land.price}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-slate-600">Expected ROI</span>
                    <span className="font-semibold text-green-600">{land.roi}</span>
                  </div>
                </div>
                <Button className="w-full bg-brand-blue text-white rounded-xl py-3">
                  View Details
                </Button>
              </div>
            ))}
          </div>
        </div>
      </section> */}

      <section className="py-20 px-4 md:px-8">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-4xl font-bold font-heading text-slate-900 mb-12 text-center">Why Invest with Britedge?</h2>
          <div className="grid md:grid-cols-4 gap-8">
            {[
              { icon: <Shield className="w-8 h-8" />, title: 'Secure', desc: 'Your investments are protected and insured' },
              { icon: <TrendingUp className="w-8 h-8" />, title: 'High Returns', desc: 'Competitive 18% annual returns' },
              { icon: <Calendar className="w-8 h-8" />, title: 'Flexible Terms', desc: 'Choose 3, 6, or 12 month periods' },
              { icon: <Award className="w-8 h-8" />, title: 'Verified', desc: 'CBN licensed and NDIC insured' }
            ].map((item, idx) => (
              <div key={idx} className="bg-white rounded-2xl p-6 shadow-sm border border-slate-200 text-center">
                <div className="w-16 h-16 rounded-2xl bg-blue-100 text-brand-blue flex items-center justify-center mx-auto mb-4">
                  {item.icon}
                </div>
                <h3 className="text-lg font-bold mb-2">{item.title}</h3>
                <p className="text-slate-600 text-sm">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 px-4 md:px-8 bg-gradient-to-br from-blue-600 to-blue-700 text-white">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl font-bold font-heading mb-6">Start Growing Your Wealth Today</h2>
          <p className="text-xl text-blue-100 mb-8">
            Join thousands of Nigerians earning guaranteed returns on their investments
          </p>
          <Button 
            onClick={() => navigate('/auth')}
            className="bg-white text-brand-blue hover:bg-indigo-50 rounded-full px-10 py-6 text-lg font-semibold"
          >
            Open Investment Account
          </Button>
        </div>
      </section>

      <Footer />
    </div>
  );
}
